import type { StreamPhase } from "../types";

interface ThinkingIndicatorProps {
  /** What the model is doing; drives dot-vs-label. Null = generic thinking. */
  phase: StreamPhase | null;
  /** Text shown for a specific named phase (e.g. searching the web). */
  label: string;
}

/**
 * Shown before the first token streams. Dot XOR label, never both:
 * a big breathing dot for generic "thinking", or the status label alone for a
 * specific named activity (e.g. web search). Keeps the pulse-dot keyframe and
 * its reduce-motion zeroing (see shared/styles/globals.css).
 */
export function ThinkingIndicator({ phase, label }: ThinkingIndicatorProps) {
  const generic = phase === null || phase === "thinking";
  return (
    <div className="flex items-center py-1 text-ink-muted" role="status">
      {generic ? (
        <span
          aria-hidden="true"
          className="size-[14px] rounded-full bg-accent [animation:pulse-dot_1.2s_ease-in-out_infinite]"
        />
      ) : (
        <span className="font-sans text-[13px]">{label}</span>
      )}
    </div>
  );
}
